export default "__VITE_ASSET__pHGDQN5H__"